import React from 'react';

const Breadcrumbs = ({ paths }) => {
  if (!paths || paths.length === 0) return null;

  return (
    <nav className="flex flex-wrap items-center gap-2 text-sm font-semibold mb-2 group">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-slate-500 group-hover:-translate-x-1 transition-transform cursor-default mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
      </svg>
      {paths.map((path, index) => {
        const isLast = index === paths.length - 1;

        return (
          <React.Fragment key={index}>
            {path.href ? (
              <a
                href={path.href}
                className="text-slate-500 hover:text-white transition-colors"
              >
                {path.name}
              </a>
            ) : (
              <span className="text-white">{path.name}</span>
            )}

            {!isLast && (
              <span className="text-slate-600">/</span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;
